import { useTranslation } from 'react-i18next';
import { useTenantStore } from '@/store/tenantStore';
import styles from './ResumeAnalyzerDialog.module.css';

/**
 * Modal shown while an uploaded resume is being analysed (Flutter `showAnalyzer` dialog):
 * SigmaResumeAnalyzeWidget when tenant config `enableSigmaAI` is set, else
 * ResumeUploadAnalyzeWidget (both in web_home_page.dart). Flutter doesn't translate the Sigma texts.
 */
export function ResumeAnalyzerDialog() {
  const { t } = useTranslation();
  const enableSigmaAI = !!(useTenantStore((s) => s.config) as Record<string, unknown> | null)
    ?.enableSigmaAI;

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-busy="true">
      {enableSigmaAI ? (
        <div className={styles.card}>
          <img src="/assets/images/agent_sigma_loader.gif" alt="" width={210} height={210} />
          <p className={styles.title}>Matching You with the Right Opportunities</p>
          <p className={styles.text}>AI Agent Sigma is matching your profile to the best-fit roles.</p>
        </div>
      ) : (
        <div className={styles.card}>
          <div className={styles.spinner} />
          <p className={`${styles.title} ${styles.brandTitle}`}>{t('Analyzing')}</p>
          <p className={styles.text}>{t('We are analyzing your profile, Please wait.')}</p>
        </div>
      )}
    </div>
  );
}
